const utils = (storeUtils = window.flex) => {

    const { getStore, setStore } = storeUtils;

    // TODO: ???
    function hideModal(Component, props) {
        flex.wrap.modal(false);
    }

    function prompt(props) {
        if (!props) {
            getStore().remove("prompt");
        }
        else {
            setStore({prompt: props});
        }
    }

    function timeoutPrompt(props) {
        if (!props) {
            getStore().remove("timeoutPrompt");
        }
        else {
            setStore({timeoutPrompt: props});
        }
    }

    return {
        hideModal,
        prompt,
        timeoutPrompt
    };
}

module.exports = utils;